import React, { useState, useEffect } from 'react';

const Menu = () => {
  const [activeCategory, setActiveCategory] = useState('all');

  useEffect(() => {
    window.scrollTo(0, 0);
    
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.1 }
    );

    document.querySelectorAll('.fade-in').forEach((el) => {
      observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  const categories = [
    { id: 'all', name: 'All Items', icon: '🍨' },
    { id: 'kulfi', name: 'Kulfi', icon: '🍡' },
    { id: 'icecream', name: 'Ice Cream', icon: '🍦' },
    { id: 'shakes', name: 'Shakes', icon: '🥤' },
    { id: 'sundae', name: 'Sundaes', icon: '🍧' },
    { id: 'special', name: 'Specials', icon: '⭐' }
  ];

  const menuItems = [
    // Kulfi Items
    {
      id: 1,
      name: 'Classic Malai Kulfi',
      description: 'Traditional creamy kulfi made with reduced milk, cardamom, and saffron',
      price: '₹60',
      category: 'kulfi',
      image: 'https://images.unsplash.com/photo-1567206563064-6f60f40a2b57?w=400&h=300&fit=crop',
      bestseller: true,
      badge: 'Classic',
      veg: true
    },
    {
      id: 2,
      name: 'Mango Kulfi',
      description: 'Fresh Alphonso mango kulfi with real mango chunks and pulp',
      price: '₹80',
      category: 'kulfi',
      image: 'https://images.unsplash.com/photo-1501443762994-82bd5dace89a?w=400&h=300&fit=crop',
      bestseller: true,
      badge: 'Seasonal',
      veg: true
    },
    {
      id: 3,
      name: 'Pista Badam Kulfi',
      description: 'Loaded with premium pistachios and California almonds',
      price: '₹90',
      category: 'kulfi',
      image: 'https://images.unsplash.com/photo-1563805042-7684c019e1cb?w=400&h=300&fit=crop',
      bestseller: true,
      badge: 'Premium',
      veg: true
    },
    {
      id: 4,
      name: 'Kesar Kulfi',
      description: 'Exotic saffron-flavored kulfi with Kashmiri kesar strands',
      price: '₹85',
      category: 'kulfi',
      image: 'https://images.unsplash.com/photo-1570197788417-0e82375c9371?w=400&h=300&fit=crop',
      bestseller: false,
      badge: 'Royal',
      veg: true
    },
    {
      id: 5,
      name: 'Rose Kulfi',
      description: 'Delicate rose-flavored kulfi with gulkand swirls',
      price: '₹70',
      category: 'kulfi',
      image: 'https://images.unsplash.com/photo-1488900128323-21503983a07e?w=400&h=300&fit=crop',
      bestseller: false,
      badge: 'Floral',
      veg: true
    },

    // Ice Cream Items
    {
      id: 6,
      name: 'Strawberry Dream',
      description: 'Fresh strawberry ice cream with real berry pieces',
      price: '₹70',
      category: 'icecream',
      image: 'https://images.unsplash.com/photo-1497034825429-c343d7c6a68f?w=400&h=300&fit=crop',
      bestseller: true,
      badge: 'Fresh',
      veg: true
    },
    {
      id: 7,
      name: 'Belgian Chocolate',
      description: 'Rich dark Belgian chocolate with chocolate chips',
      price: '₹90',
      category: 'icecream',
      image: 'https://images.unsplash.com/photo-1563589173312-476d8c36b242?w=400&h=300&fit=crop',
      bestseller: true,
      badge: 'Premium',
      veg: true
    },
    {
      id: 8,
      name: 'Vanilla Bean',
      description: 'Classic Madagascar vanilla with real vanilla beans',
      price: '₹60',
      category: 'icecream',
      image: 'https://images.unsplash.com/photo-1570197788417-0e82375c9371?w=400&h=300&fit=crop',
      bestseller: false,
      badge: 'Classic',
      veg: true
    },
    {
      id: 9,
      name: 'Butterscotch Crunch',
      description: 'Buttery caramel ice cream with crunchy praline pieces',
      price: '₹75',
      category: 'icecream',
      image: 'https://images.unsplash.com/photo-1579954115545-a95591f28bfc?w=400&h=300&fit=crop',
      bestseller: false,
      badge: 'Crunchy',
      veg: true
    },
    {
      id: 10,
      name: 'Black Current',
      description: 'Tangy black current ice cream with fruit swirls',
      price: '₹80',
      category: 'icecream',
      image: 'https://images.unsplash.com/photo-1557142046-c704a3adf364?w=400&h=300&fit=crop',
      bestseller: false,
      badge: 'Tangy',
      veg: true
    },

    // Shakes
    {
      id: 11,
      name: 'Chocolate Fudge Shake',
      description: 'Rich Belgian chocolate shake topped with whipped cream and fudge',
      price: '₹120',
      category: 'shakes',
      image: 'https://images.unsplash.com/photo-1572490122747-3968b75cc699?w=400&h=300&fit=crop',
      bestseller: true,
      badge: 'Premium',
      veg: true
    },
    {
      id: 12,
      name: 'Oreo Blast',
      description: 'Creamy vanilla shake blended with Oreo cookies',
      price: '₹130',
      category: 'shakes',
      image: 'https://images.unsplash.com/photo-1568901839119-631418a3910d?w=400&h=300&fit=crop',
      bestseller: true,
      badge: 'Popular',
      veg: true
    },
    {
      id: 13,
      name: 'Strawberry Shake',
      description: 'Fresh strawberry shake with whipped cream topping',
      price: '₹100',
      category: 'shakes',
      image: 'https://images.unsplash.com/photo-1553787499-6f9133860278?w=400&h=300&fit=crop',
      bestseller: false,
      badge: 'Fresh',
      veg: true
    },
    {
      id: 14,
      name: 'Mango Shake',
      description: 'Thick Alphonso mango shake - summer special',
      price: '₹110',
      category: 'shakes',
      image: 'https://images.unsplash.com/photo-1623065422902-30a2d299bbe4?w=400&h=300&fit=crop',
      bestseller: false,
      badge: 'Seasonal',
      veg: true
    },
    {
      id: 15,
      name: 'Cold Coffee',
      description: 'Refreshing cold coffee with ice cream and chocolate drizzle',
      price: '₹100',
      category: 'shakes',
      image: 'https://images.unsplash.com/photo-1461023058943-07fcbe16d735?w=400&h=300&fit=crop',
      bestseller: true,
      badge: 'Energizing',
      veg: true
    },

    // Sundaes
    {
      id: 16,
      name: 'Royal Rabdi Faluda',
      description: 'Traditional faluda with rabdi, vermicelli, rose syrup, and kulfi',
      price: '₹150',
      category: 'sundae',
      image: 'https://images.unsplash.com/photo-1551024506-0bccd828d307?w=400&h=300&fit=crop',
      bestseller: true,
      badge: 'Royal',
      veg: true
    },
    {
      id: 17,
      name: 'Brownie Sundae',
      description: 'Warm chocolate brownie topped with vanilla ice cream and hot fudge',
      price: '₹160',
      category: 'sundae',
      image: 'https://images.unsplash.com/photo-1563805042-7684c019e1cb?w=400&h=300&fit=crop',
      bestseller: true,
      badge: 'Indulgent',
      veg: true
    },
    {
      id: 18,
      name: 'Banana Split',
      description: 'Classic banana split with 3 ice cream flavors and toppings',
      price: '₹140',
      category: 'sundae',
      image: 'https://images.unsplash.com/photo-1579954115545-a95591f28bfc?w=400&h=300&fit=crop',
      bestseller: false,
      badge: 'Classic',
      veg: true
    },
    {
      id: 19,
      name: 'Fruit Fusion Sundae',
      description: 'Mixed seasonal fruits with vanilla ice cream and nuts',
      price: '₹130',
      category: 'sundae',
      image: 'https://images.unsplash.com/photo-1488900128323-21503983a07e?w=400&h=300&fit=crop',
      bestseller: false,
      badge: 'Healthy',
      veg: true
    },

    // Specials
    {
      id: 20,
      name: 'Kitto Special Platter',
      description: 'Assorted mini kulfis (6 pcs) with 3 different flavors',
      price: '₹250',
      category: 'special',
      image: 'https://images.unsplash.com/photo-1567206563064-6f60f40a2b57?w=400&h=300&fit=crop',
      bestseller: true,
      badge: 'Signature',
      veg: true
    },
    {
      id: 21,
      name: 'Family Feast',
      description: 'Large sundae serving for 4 with multiple ice creams and toppings',
      price: '₹450',
      category: 'special',
      image: 'https://images.unsplash.com/photo-1551024506-0bccd828d307?w=400&h=300&fit=crop',
      bestseller: false,
      badge: 'For Sharing',
      veg: true
    },
    {
      id: 22,
      name: 'Ice Cream Cake',
      description: 'Custom ice cream cake - perfect for celebrations (pre-order)',
      price: '₹800',
      category: 'special',
      image: 'https://images.unsplash.com/photo-1557979619-445218f326b9?w=400&h=300&fit=crop',
      bestseller: false,
      badge: 'Pre-Order',
      veg: true
    }
  ];

  const filteredItems = activeCategory === 'all' 
    ? menuItems 
    : menuItems.filter(item => item.category === activeCategory);

  return (
    <>
      {/* Menu Hero */}
      <section className="about-hero" style={{ minHeight: '45vh' }}>
        <div className="container">
          <div style={{ textAlign: 'center', maxWidth: '700px', margin: '0 auto' }}>
            <h1 className="gradient-text" style={{ fontSize: '3.5rem', marginBottom: '20px' }}>
              Our Menu
            </h1>
            <p style={{ fontSize: '1.2rem', opacity: 0.8 }}>
              Explore our delicious range of traditional kulfis, artisan ice creams, 
              refreshing shakes, and irresistible sundaes.
            </p>
          </div>
        </div>
      </section>

      {/* Menu Section */}
      <section className="section menu-section">
        <div className="container">
          {/* Category Tabs */}
          <div className="menu-tabs fade-in">
            {categories.map((category) => (
              <button
                key={category.id}
                className={`menu-tab ${activeCategory === category.id ? 'active' : ''}`}
                onClick={() => setActiveCategory(category.id)}
              >
                {category.icon} {category.name}
              </button>
            ))}
          </div>

          {/* Menu Grid */}
          <div className="menu-grid">
            {filteredItems.map((item, index) => (
              <div 
                key={item.id} 
                className="menu-card fade-in"
                style={{ animationDelay: `${index * 0.05}s` }}
              >
                {item.bestseller && <span className="bestseller-badge">⭐ Bestseller</span>}
                <div style={{ position: 'relative', overflow: 'hidden' }}>
                  <img src={item.image} alt={item.name} className="menu-card-image" />
                  {item.veg && (
                    <span style={{
                      position: 'absolute',
                      top: '10px',
                      left: '10px',
                      background: 'white',
                      padding: '3px 8px',
                      borderRadius: '5px',
                      fontSize: '0.75rem',
                      fontWeight: '600',
                      color: '#2e7d32',
                      border: '2px solid #2e7d32'
                    }}>
                      🟢 VEG
                    </span>
                  )}
                </div>
                <div className="menu-card-content">
                  <h3>{item.name}</h3>
                  <p>{item.description}</p>
                  <div className="menu-card-footer">
                    <span className="menu-price">{item.price}</span>
                    <span className="menu-badge">{item.badge}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Note */}
          <div className="fade-in" style={{ 
            textAlign: 'center', 
            marginTop: '60px',
            padding: '30px',
            background: 'linear-gradient(135deg, var(--pink-light), var(--cream))',
            borderRadius: '20px'
          }}>
            <h3 style={{ marginBottom: '10px' }}>📍 Visit Us Today!</h3>
            <p style={{ opacity: 0.8, marginBottom: '15px' }}>
              All items are prepared fresh daily. Prices may vary. 
              Bulk orders and party packages available on request.
            </p>
            <a href="tel:+919999999999" className="btn btn-primary">
              📞 Order Now
            </a>
          </div>
        </div>
      </section>
    </>
  );
};

export default Menu;
